import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ResolveEnd, Router } from '@angular/router';
import { EntryService } from '../entry.service';
import { Stats } from '../stats';

@Component({
  selector: 'app-nav-entries',
  templateUrl: './nav-entries.component.html',
  styleUrls: ['./nav-entries.component.less']
})
export class NavEntriesComponent implements OnInit {
  current = 0;
  count = 0;
  stats: Stats;
  @Input() useShow = true;
  @Output() gotoEntry: EventEmitter<number> = new EventEmitter<number>();

  constructor(private entryService: EntryService, private router: Router) {}

  ngOnInit(): void {
    if (this.useShow) {
      if (this.router.url === '/show55') {
        this.count = this.entryService.showentries55.length;
      } else if (this.router.url === '/show54') {
        this.count = this.entryService.showentries54.length;
      } else if (this.router.url === '/show53') {
        this.count = this.entryService.showentries53.length;
      } else {
        this.count = this.entryService.showentries.length;
      }
    } else {
      this.count = this.entryService.entries.length;
    }

    this.stats = this.entryService.stats;
  }

  atStart(): boolean {
    return (this.current === 0);
  }

  atEnd(): boolean {
    return (this.current === this.count - 1);
  }

  updateCurrent(pos: number): void {
    this.current = Math.min(Math.max(pos, 0), this.count);
    this.gotoEntry.emit(this.current);
  }

  gotoStart() {
    this.updateCurrent(0);
  }
  gotoEnd() {
    this.updateCurrent(this.count - 1);
  }
  goNext() {
    this.updateCurrent(this.current + 1);
  }
  goPrevious() {
    this.updateCurrent(this.current - 1);
  }

  initReport() {
    this.gotoEntry.emit(-1);
  }

}
